/**
 * @file Hotel Das Rehlegg is the only hotel that has access to chatbot Lulu
 * But we also enable it for dev testing hotel, for testing purposes
 */

import useParamHotelId from './router/params/useParamHotelId';

const hotelIdDevTestingProd = '67aa0d2f2f33ba40e330c551';
const hotelIdDevTestingDev = '5f993300b2985f8588fa3eff';
const hotelIdDasRehlegg = '627e3c36bd0e26459881e0b8';

const enabledForHotels = [
  hotelIdDevTestingDev,
  hotelIdDevTestingProd,
  hotelIdDasRehlegg,
];

/**
 * Check if chatbot Lulu is enabled for the current hotel
 *
 * @returns Whether chatbot Lulu is enabled
 */
const useCanAccessChatbotLulu = (): boolean => {
  const hotelId = useParamHotelId();

  if (hotelId === null) {
    return false;
  }

  return enabledForHotels.includes(hotelId);
};

export default useCanAccessChatbotLulu;
